<template lang="pug">
div.dashboard-find
  h2 {{lang['Dashboard - choose criteria']}}
    small.text-muted &nbsp;({{lang['Limit of states']}})
  form.form-inline
    .form-group
      label.label {{lang['Restaurant (mpk)']}}
        sup *
      input.form-control(v-model='mpk')
    .form-group
      label.label {{lang['Date from']}}
        sup *
      date-picker(v-model='dateFrom' :config='pickerConfig')
    .form-group
      label.label {{lang['Date to']}}
        sup *
      date-picker(v-model='dateTo' :config='pickerConfig2')
    button.btn.btn-default(@click.prevent='getData()') {{lang['Find']}}
    br
    .small * {{lang['required']}}
    .small ** {{lang['Duration in seconds']}}

  .container-fluid.result(v-if='dashboard')
    .downtime.col-md-2
      h3 {{lang['Downtime']}}
      table.table.table-bordered
        thead
          tr
            th
            th {{lang['Time']}}
        tbody
          tr
            th {{lang['Total']}}
            td {{downtimes.total | formatDurationDays(lang.lang)}}
          tr
            th {{lang['Per Kiosk']}}
            td {{downtimes.perDevice | formatDurationDays(lang.lang)}}
          tr
            th(colspan='2') {{lang['Kiosks']}}
          tr(v-for='(device, index) in dashboard.devices', :key='index')
            th {{device.name}}
            td {{device.downtime | formatDurationDays(lang.lang)}}
    .statuses.col-md-5
      h3 Status & failures
      ul.nav.nav-tabs
        li.nav-item(v-for='(device, index) in dashboard.devices', :key='index' :class='{ active: selectedKiosk === device.name }')
          a.nav-link(v-on:click='selectedKiosk=device.name') {{device.name}}
      .kioskStatus(v-for='(device, index) in dashboard.devices', :key='index')
        div(v-if='device.name==selectedKiosk && allStatuses.filter(el => el.device === device.id).length > 0')
          h4 {{device.name}}
          table.table.table-bordered
            thead
              tr
                th {{lang['Status']}}
                th {{lang['Time']}}
                th {{lang['Error']}}
                th {{lang['Beginning time']}}
            tbody
              tr(v-for='(status, index2) in allStatuses.filter(el => el.device === device.id)', :key='index2', :class='status.status | eqStatus')
                th {{status.status}}
                td {{status.duration | formatDurationDays(lang.lang)}}
                td
                  .errors(v-if='status.errors')
                    .error(v-for='(error, index3) in status.errors', :key='index3') {{error.status_description | translateError(lang.lang)}}
                td {{status.createdAt | formatDateTime}}
    .col-md-5
      h3 Status & failures summary
      table.table.table-bordered
        thead
          tr
            th {{lang['Status']}}
            th {{lang['Time']}}
        tbody
          tr(v-for='(status, name, index) in statusTimes.status', :key='index', :class='name | eqStatus')
            th {{name}}
            td {{status | formatDurationDays(lang.lang)}}
      table.table.table-bordered.table-striped
        thead
          tr
            th {{lang['Error']}}
            th {{lang['Time']}}
        tbody
          tr(v-for='(error, name, index) in errorTimes', :key='index', :class='error.status | eqStatus')
            th {{name | translateMultiErrorPlainText(lang.lang)}}
            td {{error.duration | formatDurationDays(lang.lang)}}
</template>
<script>
export default {
  props: ['lang'],
  data () {
    return {
      pickerConfig: {format: 'YYYY-MM-DD HH:mm', maxDate: this.$moment().format('YYYY-MM-DD HH:mm'), minDate: false, icons: {time: 'fa fa-lg fa-clock'}},
      pickerConfig2: {format: 'YYYY-MM-DD HH:mm', maxDate: this.$moment().format('YYYY-MM-DD HH:mm'), minDate: false, icons: {time: 'fa fa-lg fa-clock'}},
      // mpk: '103006',
      mpk: '',
      // dateFrom: '2021-11-17 19:24',
      // dateTo: '2021-11-18 19:24',
      dateFrom: this.$moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
      dateTo: this.$moment().format('YYYY-MM-DD HH:mm'),
      dashboard: undefined,
      usePayment: null,
      downtimes: undefined,
      statusTimes: undefined,
      errorTimes: undefined,
      kioskStatuses: undefined,
      allStatuses: undefined,
      selectedKiosk: undefined
    }
  },
  computed: {
    console: () => console,
    userNetworks () {
      return this.$store.getters.networks.filter((n) => this.$store.getters.user.networks.includes(n.id))
    }
  },
  methods: {
    getData () {
      if (this.mpk.length <= 0) {
        return this.$notify(this.lang['MPK cannot be empty'], 'error')
      }
      if (!this.dateFrom || !this.dateTo) {
        return this.$notify(this.lang['Please select dates'], 'error')
      }
      this.$http.post('dashboard/statuschange', { mpk: this.mpk, dateFrom: this.$moment(this.dateFrom).valueOf(), dateTo: this.$moment(this.dateTo).valueOf() })
        .then(response => {
          return response.json()
        })
        .then(data => {
          if (process.env.NODE_ENV !== 'production') {
            console.log(data)
          }
          this.selectedKiosk = data.devices[0].name
          this.dashboard = data
          this.calculateDowntimes(data.devices)
          this.harvestErrors(data.statuses)
        })
    },
    harvestErrors (statuses) {
      const deviceStatuses = []
      this.dashboard.devices.forEach((device, index) => {
        deviceStatuses[index] = (statuses.filter(el => el.device === device.id).map(el => {
          const newEl = {}
          newEl.device = el.device
          newEl.createdAt = el.createdAt
          newEl.failure = el.failure
          newEl.errors = JSON.parse(el.errors)
          newEl.status = el.status
          return newEl
        }).sort((a, b) => a.createdAt - b.createdAt))
      })
      const result = []
      deviceStatuses.forEach(statuses => {
        for (let index = 0; index < statuses.length; index++) {
          let newEl
          newEl = statuses[index]
          newEl.duration = 0
          if (statuses[index + 1]) {
            newEl.duration = statuses[index + 1].createdAt - statuses[index].createdAt
          }
          result.push(newEl)
        }
      })
      this.kioskStatuses = deviceStatuses
      this.allStatuses = result
      this.calculateStatusTimes(this.allStatuses)
      this.calculateErrorTimes(this.allStatuses)
    },
    calculateDowntimes (devices) {
      let total = 0
      devices.map(el => { total += el.downtime })
      const downtimes = {}
      downtimes['total'] = total
      downtimes['perDevice'] = downtimes['total'] / devices.length
      this.downtimes = downtimes
    },
    calculateStatusTimes (data) {
      const statusTimes = {}
      statusTimes.status = data.reduce((subtotal, obj) => {
        let key = obj['status']
        if (!subtotal[key]) {
          subtotal[key] = 0
        }
        subtotal[key] += obj.duration
        return subtotal
      }, {})
      this.statusTimes = statusTimes
    },
    calculateErrorTimes (data) {
      const errorTimes = data.reduce((subtotal, obj) => {
        let key = 'none'
        if (typeof obj.failure.errors !== 'undefined') {
          key = obj.failure.errors.reduce((previousValue, currentValue) => {
            let div = ''
            if (previousValue.length) {
              div = '<br>'
            }
            return `${previousValue}${div}${currentValue.status_description}`
          }, '')
        }
        if (!subtotal[key]) {
          subtotal[key] = {duration: 0, status: ''}
        }
        subtotal[key].duration += obj.duration
        subtotal[key].status = obj.status
        delete subtotal['none']
        return subtotal
      }, {})
      this.errorTimes = errorTimes
    }
  }
}
</script>
<style lang="sass">
.dashboard-find
  .label
    margin-left: 8px
    margin-right: 4px
    font-size: 100%
  .btn
    margin-left: 8px
  table
    margin-top: 8px
    td
      cursor: pointer
  .downtime
    float: left
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Find.vue